import type { SVGAttributes } from "react";

export default function EditIcon(props: SVGAttributes<SVGElement>) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.7313 2.26869C21.239 1.7765 20.5714 1.5 19.8753 1.5C19.1791 1.5 18.5115 1.7765 18.0193 2.26869L16.8623 3.42569L20.5743 7.13769L21.7313 5.98069C22.2234 5.48842 22.4999 4.82081 22.4999 4.12469C22.4999 3.42857 22.2234 2.76096 21.7313 2.26869ZM19.5133 8.19869L15.8013 4.48669L7.40125 12.8867C6.78411 13.5035 6.33043 14.2645 6.08125 15.1007L5.28125 17.7857C5.24263 17.9153 5.23975 18.0529 5.27292 18.1839C5.30608 18.315 5.37407 18.4347 5.46967 18.5303C5.56527 18.6259 5.68494 18.6939 5.81601 18.727C5.94709 18.7602 6.08469 18.7573 6.21425 18.7187L8.89925 17.9187C9.73548 17.6695 10.4964 17.2158 11.1133 16.5987L19.5133 8.19869Z"
        fill="currentColor"
      />
      <path
        d="M5.25 5.25C4.45435 5.25 3.69129 5.56607 3.12868 6.12868C2.56607 6.69129 2.25 7.45435 2.25 8.25V18.75C2.25 19.5456 2.56607 20.3087 3.12868 20.8713C3.69129 21.4339 4.45435 21.75 5.25 21.75H15.75C16.5456 21.75 17.3087 21.4339 17.8713 20.8713C18.4339 20.3087 18.75 19.5456 18.75 18.75V13.5C18.75 13.3011 18.671 13.1103 18.5303 12.9697C18.3897 12.829 18.1989 12.75 18 12.75C17.8011 12.75 17.6103 12.829 17.4697 12.9697C17.329 13.1103 17.25 13.3011 17.25 13.5V18.75C17.25 19.1478 17.092 19.5294 16.8107 19.8107C16.5294 20.092 16.1478 20.25 15.75 20.25H5.25C4.85218 20.25 4.47064 20.092 4.18934 19.8107C3.90804 19.5294 3.75 19.1478 3.75 18.75V8.25C3.75 7.85218 3.90804 7.47064 4.18934 7.18934C4.47064 6.90804 4.85218 6.75 5.25 6.75H10.5C10.6989 6.75 10.8897 6.67098 11.0303 6.53033C11.171 6.38968 11.25 6.19891 11.25 6C11.25 5.80109 11.171 5.61032 11.0303 5.46967C10.8897 5.32902 10.6989 5.25 10.5 5.25H5.25Z"
        fill="currentColor"
      />
    </svg>
  );
}
